<template>
	<div class="home">
		<div class="banner">
			<headNav :activeNav="'home'"></headNav>
			<div class="title">
				<p>
					¡Solicite préstamos rápidos<br />
					y seguros en cualquier<br />
					momento y en cualquier lugar!
				</p>
				<a
					target="blank"
					href="https://play.google.com/store/apps/details?id=credit.cash.prestamo.profin.loan.efectivo.luckyplata&gl=CO&hl=es-CO&pli=1"
					class="playBtn"
					><img src="@/assets/image/playBtn.png" alt="" />
				</a>
			</div>
		</div>
		<div class="container">
			<div class="container_clsOne">
				<h1>Cómo obtener un préstamo en LuckyPlata?</h1>
				<div class="clsOne_wrapper">
					<div>
						<img src="../assets/image/p4_1.png" alt="" />
						<div class="big">Descargar la App</div>
						<div class="small">
							Descargar LuckyPlata en<br />
							<a
								target="blank"
								href="https://play.google.com/store/apps/details?id=credit.cash.prestamo.profin.loan.efectivo.luckyplata&gl=CO&hl=es-CO&pli=1"
								>Google Play</a
							>
						</div>
					</div>
					<div>
						<img src="../assets/image/p4_2.png" alt="" />
						<div class="big">Llenar un formulario</div>
						<div class="small">
							Crear la cuenta con solo 4<br />
							pasos sencillos para entregar la<br />
							solicitud
						</div>
					</div>
					<div>
						<img src="../assets/image/p4_3.png" alt="" />
						<div class="big">Esperar un momento</div>
						<div class="small">Esperar la aprobación del préstamo</div>
					</div>
					<div>
						<img src="../assets/image/p4_4.png" alt="" />
						<div class="big">Depósito exitoso</div>
						<div class="small">
							Depositamos el dinero del<br />
							préstamo directamente en<br />
							su cuenta bancaria
						</div>
					</div>
				</div>
			</div>
			<div class="container_clsTwo">
				<div class="left">
					<h1>Requisitos para solicitar un préstamo</h1>
					<div>
						<div class="left_clsOne">
							<img src="../assets/image/p3_1.png" alt="" />
							<span>Cumplir la mayoría de edad</span>
						</div>
						<div class="left_clsOne">
							<img src="../assets/image/p3_2.png" alt="" />
							<span> Tener la C.C.ID vigente</span>
						</div>
						<div class="left_clsOne">
							<img src="../assets/image/p3_3.png" alt="" />
							<span>Contar con una propia tarjeta bancaria</span>
						</div>
						<div class="left_clsOne">
							<img src="../assets/image/p3_4.png" alt="" />
							<span>Tener su propio teléfono celular y correo electrónico</span>
						</div>
					</div>
				</div>
				<div class="right">
					<img src="../assets/image/p3_5.png" alt="" />
				</div>
			</div>
		</div>
		<footPage></footPage>
	</div>
</template>

<script>
	import footPage from '@/components/foot.vue'
	import HeadNav from '@/components/headNav.vue'
	import '../components/scss/home.scss'
	export default {
		name: 'home',
		components: { footPage, HeadNav },
		data() {
			return {
				activeNav: 'Inicio',
				changeNum: 0,
				sliderValue: 5000,
				currentdate: '',
				addDate: '',
				isActive: 61,
			}
		},
		created() {
			let nav = localStorage.getItem('activeNav')
			if (nav) {
				this.activeNav = nav
			} else {
				localStorage.setItem('activeNav', this.activeNav)
			}
			this.getNowFormatDate()
		},
		methods: {
			getDays(day) {
				this.isActive = day
				this.dateAddDays(this.currentdate, day)
			},
			dealNumber(num) {
				if (num != 0 && num) {
					num = num + ''
					let splitList = num.split('.')
					//将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
					let intStrList = splitList[0]
						.split('')
						.reverse()
						.join('')
						.match(/(\d{1,3})/g)
					//将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
					let intStr = intStrList.join(',').split('').reverse().join('')
					return intStr
				}
				return num
			},
			dateAddDays(dateStr, dayCount) {
				var tempDate = new Date(dateStr.replace(/-/g, '/')) //把日期字符串转换成日期格式
				var resultDate = new Date((tempDate / 1000 + 86400 * dayCount) * 1000) //增加n天后的日期
				let mounth = (resultDate.getMonth() + 1).toString()
				if (mounth.length == 1) {
					mounth = '0' + mounth
				}
				let today = resultDate.getDate().toString()
				if (today.length == 1) {
					today = '0' + today
				}

				var resultDateStr = today + '-' + mounth + '-' + resultDate.getFullYear() //将日期转化为字符串格式
				this.addDate = resultDateStr
			},
			getNowFormatDate() {
				var date = new Date()
				var seperator1 = '-'
				var year = date.getFullYear()
				var month = date.getMonth() + 1
				var strDate = date.getDate()
				if (month >= 1 && month <= 9) {
					month = '0' + month
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = '0' + strDate
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate
				this.currentdate = currentdate
				this.getDays(90)
			},
		},
	}
</script>

<style scoped>
	.home {
		width: 100%;
		height: 100%;
		background-color: #fff;
		margin: 0;
		padding: 0;
	}
</style>
